import { render, staticRenderFns } from "./common-height-changetab.vue?vue&type=template&id=3a05a628&scoped=true"
import script from "./common-height-changetab.vue?vue&type=script&lang=js"
export * from "./common-height-changetab.vue?vue&type=script&lang=js"
import style0 from "./common-height-changetab.vue?vue&type=style&index=0&id=3a05a628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a05a628",
  null
  
)

export default component.exports